interface GetItemlookupAction {
  type: ItemlookupActionTypes.GET_NS_ITEM;
  payload: any[];
}

interface GetItemlookupBinsAction {
  type: ItemlookupActionTypes.GET_NS_ITEM_BINS;
  payload: any[];
}

interface SetIemlookupLoadingAction {
  type: ItemlookupActionTypes.SET_NS_ITEM_LOADING;
}

interface SetIemlookupBinsLoadingAction {
  type: ItemlookupActionTypes.SET_NS_ITEM_BINS_LOADING;
}

interface ClearItemlookupAction {
  type: ItemlookupActionTypes.CLEAR_ITEMLOOKUP;
}

export enum ItemlookupActionTypes {
  GET_NS_ITEM = 'GET_NS_ITEM',
  GET_NS_ITEM_BINS = 'GET_NS_ITEM_BINS',
  SET_NS_ITEM_LOADING = 'SET_NS_ITEM_LOADING',
  SET_NS_ITEM_BINS_LOADING = 'SET_NS_ITEM_BINS_LOADING',
  CLEAR_ITEMLOOKUP = 'CLEAR_ITEMLOOKUP'
}

export interface ItemlookupState {
  items: any[];
  itemBins: any[];
  message: string;
  loading: boolean;
  loadingBins: boolean;
}

export type ItemlookupAction =
  | SetIemlookupLoadingAction
  | SetIemlookupBinsLoadingAction
  | GetItemlookupAction
  | GetItemlookupBinsAction
  | ClearItemlookupAction;
